import "./contact.css";
import Phone from "../../img/phone.png";
import Email from "../../img/email.png";
import Address from "../../img/address.png";
import { useContext, useRef, useState } from "react";
import emailjs from "emailjs-com";
import { ThemeContext } from "../../context";

const Contact = () => {
  const formRef = useRef();
  const [done, setDone] = useState(false)
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_rrvnzco",
        "template_3v5nih4",
        formRef.current,
        "user_DrriDPTGKO2Zj4RDXCA6W"
      )
      .then(
        (result) => {
          console.log(result.text);
          setDone(true)
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="c">
      <div className="c-bg"></div>
      <div className="c-wrapper">
        <div className="c-left">
          <h1 className="c-title">Let's discuss your project</h1>
          <div className="c-info">
            <div className="c-info-item">
              <img src={Phone} alt="" className="c-icon" />
              +234 7019318840
            </div>
            <div className="c-info-item">
              <img className="c-icon" src={Email} alt="" />
              patrick.obafemi@artisaans.ng
            </div>
            <div className="c-info-item">
              <img className="c-icon" src={Address} alt="" />
              Suite 8 Dove Court Estate, Clubhouse, Abuja
            </div>
          </div>
        </div>
        <div className="c-right">
          <h2 className="c-desc">
            My Social Links
          </h2>
          {/* <form ref={formRef} onSubmit={handleSubmit}>
            <input style={{backgroundColor: darkMode && "#333"}} type="text" placeholder="Name" name="user_name" />
            <input style={{backgroundColor: darkMode && "#333"}} type="text" placeholder="Subject" name="user_subject" />
            <input style={{backgroundColor: darkMode && "#333"}} type="text" placeholder="Email" name="user_email" />
            <textarea style={{backgroundColor: darkMode && "#333"}} rows="5" placeholder="Message" name="message" />
            <button>Submit</button>
            {done && "Thank you..."}
          </form> */}
          <a className="c-links" href="https://twitter.com/eloquentcoder">Twitter</a>
          <a className="c-links" href="https://github.com/eloquentcoder">Github</a>
          <a className="c-links" href="https://www.linkedin.com/in/patrick-obafemi-b6a77510a/">Linkedin</a>

        </div>
      </div>
    </div>
  );
};

export default Contact;
